export const ADMIN_SESSION_EXPIRED_EVENT = 'admin-session-expired';

/**
 * @param {{ message: string, isQrWarning?: boolean }} detail
 */
export function dispatchAdminSessionExpired(detail) {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(ADMIN_SESSION_EXPIRED_EVENT, { detail }));
  }
}
